/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询旗舰店详情
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.TheaterShopInfoDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/shop/info`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
